import BASEURL from "../Config/global";
import Common from "./common";

let playedTrackIds = new Set();
const url_type = {
  'relax-rest': 'meditation',
  'articles': 'articles',
  'stories': 'stories',
}

export const isVideoUrl = (url) => {
  return url != undefined && url != 'undefined' && url != null && url != '';
};

export const getPlaylistType = (item) => {
  const allowOptions = ["relaxation", "articles", "stories"]
  let type = 'default';
  if (allowOptions.includes(item?.type)) {
    type = "article_stories_relaxation";
  } else if (item?.type === "sounds") {
    if (item?.soundcategory === 163 || item?.soundcategory === 164) {
      type = "music_lullaby";
    }
  }
  return type;
};

export const showPlaylistOption = (item) => {
  const allowOptions = ["relaxation", "articles", "stories", "sounds", 163, 164]
  return (!isVideoUrl(item?.video_url) && (allowOptions.includes(item?.type) || allowOptions.includes(item?.soundcategory)));
};

export const isProtectedRouteForBottomPlayerBar = () => {
  const path = window.location.pathname;
  const excludedRoutes = ['/mobile-video', '/share.mix', '/share.playlist', '/404', '/qr-code', '/mobile-webview-infobox', '/install-mobile-app', '/payment', '/login', '/signup', '/forgot-password', '/verification', '/reset-password', '/subscription', '/package-details', '/promo', '/freetrial', '/download-app', '/deal'];
  return path === '/' || excludedRoutes.some(route => path.toLocaleLowerCase().includes(route));
};

export const getMediaTypeTitle = (type) => {
  return Common['MEDIA_TYPES'][type]
}

export const formatTime = (time) => {
  if (isNaN(time)) return "0:00";
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60).toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
}

export const getSpecificEndPoint = (type, id) => {
  const url = `${BASEURL}/api/${url_type[type]}/${id}`;
  return url;
}

export const flattenPlaylistTracks = (tracks = {}) => {
  if (!tracks || typeof tracks !== "object") {
    console.error("Invalid input: tracks must be an object");
    return [];
  }

  const data_set = Object.values(tracks)
    .filter(Array.isArray) // only process arrays
    .flatMap(arr => arr)   // flatten arrays
    .filter(item => item && Object.keys(item).length); // ignore empty objects

  return data_set;
};

export const flattenSoundMixtureTracks = (item) => {
  if (!item || !Array.isArray(item.sounds_list)) {
    console.warn("Invalid item passed to flattenSoundMixtureTracks:", item);
    return [];
  }

  return item.sounds_list
    .map((s) => s?.sounds_detail?.[0])   // pick first detail if exists
    .filter(Boolean);                    // remove null/undefined
};

export const getPlaylistConfig = (data, type) => {
  if (!data) return [];

  const items = Array.isArray(data) ? data : [data];
  return items.map(({ id, type: itemType }) => ({
    id,
    type: itemType || 'sounds'
  }));

};

export const getModifiedPlayload = (data, type) => {
  if (!data) return [];

  const items = Array.isArray(data) ? data : [data];
  return items.map(({ id, type: itemType }) => ({
    id,
    type: itemType || 'sounds'
  }));

};

export const getPlaylistOrder = (data, type) => {

  const getOrder = (item) => {
    if (item.type === "sounds" && item.soundcategory === 164) return 0; // music
    if (item.type === "relaxation") return 1;
    if (item.type === "articles") return 2;
    if (item.type === "stories") return 3;
    if (item.type === "sounds") return 4; // normal sounds
    return 5; // fallback
  };

  const reordered = [...data].sort((a, b) => getOrder(a) - getOrder(b));

  return reordered || [];

};

export const getRandomTrackId = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  // Filter valid items
  const filteredItems = arr.filter(
    (item) =>
      item.type !== "sounds" ||
      item.category === 164 ||
      item.category === 163
  );

  if (filteredItems.length === 0) return null;

  // Skip the first track (index 0 auto plays)
  if (playedTrackIds.size === 0) {
    playedTrackIds.add(filteredItems[0].id);
  }

  // Stop when all have been played
  if (playedTrackIds.size >= filteredItems.length) {
    console.log("All tracks played in shuffle mode");
    return null;
  }

  // Filter out already played tracks
  const available = filteredItems.filter((item) => !playedTrackIds.has(item.id));

  // Pick random track
  const randomItem = available[Math.floor(Math.random() * available.length)];

  playedTrackIds.add(randomItem.id);

  return randomItem.id;
};

export const setTrackIdToRandomList = (id) => {
  if (!playedTrackIds.has(id)) {
    playedTrackIds.add(id);
  } else {
    console.log("ID already exists in Shuffle List");
  }
};

export const getNextTrackId = (arr, isRepeat) => {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  const isAudio = ["relaxation", "articles", "stories"];

  // Filter valid tracks only once
  const filteredTracks = arr.filter(
    (item) =>
      isAudio.includes(item.type) ||
      (item.type === "sounds" && (item.category === 164 || item.category === 163))
  );

  if (filteredTracks.length === 0) return null;

  // Move to next index
  currentTrackId++;

  // If end reached
  if (currentTrackId >= filteredTracks.length) {
    if (isRepeat) {
      currentTrackId = 0; // restart loop
    } else {
      console.log("All tracks played sequentially");
      return null; // stop playback
    }
  }

  return filteredTracks[currentTrackId].id;
};

export const resetTrackIds = () => {
  playedTrackIds.clear();
  currentTrackId = -1;
};

export const areAllModalsClosed = (modalState) => {
  const {
    isSucessModal,
    isOpenSaveMixModal,
    isOpenShareMixModal,
    isShareMixOnSave,
    isOpenCreatePlaylistModal,
    isOpenEditPlaylistModal,
    isOpenRemovePlaylistModal,
  } = modalState;

  return [
    isSucessModal,
    isOpenSaveMixModal,
    isOpenShareMixModal,
    isShareMixOnSave,
    isOpenCreatePlaylistModal,
    isOpenEditPlaylistModal,
    isOpenRemovePlaylistModal,
  ].every((v) => !v);
};


let trackingList = [], currentTrackId = null;

export const GetPlaylistNextTrackId = (tracks, config) => {

  if (!Array.isArray(tracks) || tracks.length === 0) return null;


  // Filter valid items
  const filteredSounds = tracks.filter(
    (item) => item.type !== "sounds" || item.category === 164 || item.category === 163
  );

  const filteredItems = filteredSounds.filter(
    (item) => item.id !== config.shouldPlay
  );

  if (filteredItems.length === 0) return null;

  // Stop when all have been played
  if (trackingList.length >= filteredItems.length) {
    if (config?.isRepeat || config?.playlist_type === "music_lullaby") {
      const randomItem = config?.isShuffle ? config?.playlist_type === "music_lullaby" ? filteredItems[Math.floor(Math.random() * filteredItems.length)] : filteredItems[0] : filteredItems[0];
      currentTrackId = randomItem.id;
      trackingList = [currentTrackId];
      return currentTrackId;
    }
    console.log("All tracks played!!");
    return null;
  }

  // Filter out already played tracks
  const available = filteredItems.filter((item) => !trackingList.includes(item.id));

  // Pick random track
  const randomItem = config?.isShuffle ? available[Math.floor(Math.random() * available.length)] : available[0];


  // Update current track IDs and shuffle list
  trackingList.push(randomItem.id);
  currentTrackId = randomItem.id;

  return randomItem.id;
}

export const SetPlaylistTrackId = (id) => {
  trackingList.push(id);
  currentTrackId = id;
}

export const InitPlaylistTrackingIds = (id) => {
  trackingList = [id];
  currentTrackId = id;
}

export const hasSingleType = (arr) => {
  if (!arr.length) return false;
  return new Set(arr.map(item => item.type)).size === 1;
};


export const GetSelectedTrackIdByPlaylistType = (item, config) => {
  const playlist_type = config?.playlist_type;
  const majorTypes = ['stories', 'articles', 'relaxation'];
  const shouldPlay = config?.shouldPlay;
  if (playlist_type === 'music_lullaby' && majorTypes.includes(item?.type)) {
    return item?.id;
  }
  if (playlist_type === 'article_stories_relaxation' && (item.soundcategory === 163 || item.soundcategory === 164)) {
    return item?.id;
  }
  return shouldPlay;
}